<template>
  <BaseModal v-model="showModal" ref="modal">
    <form @submit.prevent="onSubmit">
      <label>
        ¿Esta seguro que desea eliminar la evaluación:
        <b>{{evaluation?.name }}</b>
        ?
      </label>
      <br>
      <button type="submit" class="btn btn-danger mt-2" :disabled="processing">
        <b-spinner v-show="processing" small/>
        Eliminar
      </button>
    </form>
  </BaseModal>
</template>
<script>
import BaseModal from "@/components/shared/Base-modal.vue"
import {EventNames} from "@/plugins/enums/index.js"
import {mapActions} from "vuex"

export default {
  name: "EvaluationDelete",

  components: {
    BaseModal,
  },

  data() {
    return {
      processing: false,
      showModal: false,
      evaluation: null,
      courseId: null,
    }
  },

  mounted() {
    this.$eventBus.$on(EventNames.OpenModalDeleteEvaluation, ({evaluation, courseId}) => {
      this.evaluation = evaluation
      this.courseId = courseId
      this.showModal = true
    })
  },

  methods: {
    ...mapActions(["deleteEvaluation"]),
    async onSubmit() {
      this.processing = true
      let result = await this.deleteEvaluation({evaluationId: this.evaluation.id})

      if (result.isError) {
        this.$refs.modal.showAlert(result.message, "warning")
        this.processing = false
        return
      }

      this.$refs.modal.showAlertExternal("Evaluación eliminada correctamente", "success")
      this.processing = false
      this.showModal = false
      this.evaluation = false
      this.$eventBus.$emit(EventNames.UpdateCurrentCurriculum, {courseId: this.courseId})
    }
  }
}
</script>